import { Capacitor } from '@capacitor/core';
import { TokenAuthOptions } from '@panamax/app-state';

export class CommonUtils {
  static isValidGuid(token: string) {
    let regex = new RegExp(
      /^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/,
    );
    if (!token) {
      return false;
    }
    return regex.test(token);
  }
}
